<style scoped>
    .info{
        display: inline-block;
        margin: 0 10px;
        vertical-align: middle;
    }
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
    }
</style>
<template>
  <div>
    <div
      v-show="topic.name"
      class="line text-center"
    >
      <div class="line">
        <Select
          v-model.number="params.team_id"
          placeholder="团队"
          style="width: 150px"
          @on-change="doSearch"
        >
          <Option :value="0">
            所有团队
          </Option>
          <Option
            v-for="team in teams"
            :key="team.id"
            :value="team.id"
          >
            {{ team.name }}
          </Option>
        </Select>
        <div class="search-input">
          <Input
            v-model="params.search"
            placeholder="请输入搜索关键字"
            @on-enter="doSearch"
          />
        </div>
        <Ajaxbtn
          ref="searchBtn"
          :url="get_detail_path"
          :params="params"
          type="search"
          @before="beforeSearch"
          @done="handleData"
          @fail="handleFail"
        />
      </div>
      <div class="line">
        <h2>
          {{ topic.wage_month + ' ' + topic.name }}
          <small>({{ topic.wage_start + ' - ' + topic.wage_end }})</small>
        </h2>
        <h2>
          付款数量: {{ topic.wage_count }},
          付款总金额: ￥{{ $util.formatPrice(topic.wage_total) }}
        </h2>
        <h3>付款: {{ bank_info }}</h3>
        <!-- <h3>支付宝付款: {{ alipay_info }}</h3> -->
      </div>

      <Button
        icon="md-refresh"
        @click="getOutsourceWageTopicDetail()"
      >
        刷新数据
      </Button>
      <Button
        v-show="!isTopicFinished && !isTopicPaid"
        type="primary"
        :loading="updating_status"
        @click="updateTopicStatus(5)"
      >
        关闭填写通道
      </Button>
      <Button
        v-show="isTopicFinished"
        :loading="updating_status"
        @click="updateTopicStatus(1)"
      >
        重新开启
      </Button>
      <Button
        @click="showFlowStatus"
      >
        查看流程状态
      </Button>
      <Button
        @click="exportAllRecords"
      >
        导出付款数据
      </Button>
      <Button
        v-show="isTopicFinished"
        type="primary"
        :loading="paying"
        @click="batchPay"
      >
        开始付款
      </Button>
      <div
        v-if="isTopicPaid"
        class="line text-large color-success"
      >
        已提交付款
      </div>
    </div>
    <div class="list-container">
      <Table
        border
        :row-class-name="rowClassName"
        :columns="records_columns"
        :data="records"
        :no-data-text="empty_tip"
        size="small"
      />
      <Backdrop v-show="loading" />
    </div>
    <div class="line">
      <span class="color-error">[红色]</span>表示该条工资记录未发放, 已被废弃.
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <Modal
      v-model="edit_config.modal"
      :title="edit_record.account"
      width="600"
      :loading="edit_config.loading"
      ok-text="确定"
      @on-ok="editRecordOK"
    >
      <Form ref="formInline">
        <Form
          ref="formCustom"
          :label-width="80"
        >
          <FormItem label="员工姓名">
            <span>{{ edit_record.account }}</span>
            <span> (如需修改，请到云账户合同上修改)</span>
          </FormItem>
          <FormItem label="银行卡号">
            <i-input
              v-model="edit_record.bank_number"
              placeholder="银行卡或支付宝"
            />
          </FormItem>
          <div class="color-error">
            请同时修改本记录和云账户合同上的卡号，不能将银行卡改为支付宝或相反
          </div>
        </Form>
      </Form>
    </Modal>

    <VModal
      v-model="status_config.modal"
      title="流程状态"
      width="800"
      cancel-text=""
    >
      <Table
        :columns="director_topic_columns"
        :data="director_topics"
        :loading="getting_director_topics"
      />
    </VModal>
  </div>
</template>
<script :route="{path: '/fin/outsource_wage_topic_detail/:id',noChkout: true}">
  import VModal from '../../vuetify_custom/v-modal';
  import ViewerItem from '../components/viewer/item';
  import UserFlowBase from '../components/flow/user_flow_base';
  import {mapGetters} from "vuex";

  export default {
    components: { VModal, UserFlowBase },
    data() {
      return {
        get_detail_path: this.$util.api.outsource_wage_topic_detail,
        topic: {},
        records: [],
        page_records: [],
        records_columns: [
          {
            title: '合同号',
            key: 'uid',
            align: 'center',
            fixed: 'left',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              return h(ViewerItem, {
                props: {
                  type: 'OutsourceContract',
                  model_id: row.outsource_contract_id,
                  tip: false
                },
                'class': {
                  link: true
                }
              }, row.uid);
            }
          },
          {
            title: '姓名',
            key: 'account',
            align: 'center',
            fixed: 'left',
            width: 100,
          },
          {
            title: '证件号',
            key: 'id_number',
            align: 'center',
            width: 130,
            render: (h, params) => {
              const record = params.row;
              const contract = record.outsource_contract;
              return h('span', contract.id_number);
            }
          },
          {
            title: '收款账户核验',
            align: 'center',
            width: 130,
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.threeCheckStatusName(row.three_check_status));
            }
          },
          {
            title: '工作内容',
            key: 'job_content',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const record = params.row;
              const contract = record.outsource_contract;
              return h('span', contract.job_content);
            }
          },
          {
            title: '支付信息',
            key: 'name',
            width: 130,
            render: (h, params) => {
              const record = params.row;
              let bank_type = '';
              if (record.bank_type === 'bank') {
                bank_type = '银行卡';
              } else if (record.bank_type === 'alipay') {
                bank_type = '支付宝';
              } else {
                bank_type = '未定义支付方式';
              }
              return h('div', `${bank_type}: ${record.bank_number}`);
            }
          },
          {
            title: '团队',
            key: 'team',
            width: 100,
            render: (h, params) => {
              const record = params.row;
              return h('div', record.team.full_name);
            }
          },
          {
            title: '负责人',
            key: 'director',
            width: 100,
            render: (h, params) => {
              const record = params.row;
              return h('span', record.director);
            }
          },
          {
            title: '工资(￥)',
            key: 'total_wage',
            fixed: 'right',
            align: 'right',
            width: 80,
            render: (h, params) => {
              const record = params.row;
              return h('span', this.$util.formatPrice(record.total_wage));
            }
          },
          {
            title: '付款状态',
            fixed: 'right',
            align: 'center',
            width: 120,
            render: (h, params) => {
              const record = params.row;
              if (record.status === 6) {
                return h('div', record.err_msg);
              } else if (record.expense_payment_record) {
                const payment_record = record.expense_payment_record;
                if (payment_record.status === 'submit' || payment_record.status === 'success') {
                  return h('div', payment_record.status);
                } else {
                  return h('div', `${payment_record.status}: ${payment_record.err_msg}`);
                }
              }
              return h('span', '-');
            }
          },
          {
            title: '操作',
            key: 'action',
            fixed: 'right',
            align: 'center',
            width: 140,
            render: (h, params) => {
              const record = params.row;
              const ret = [];
              if (record.can_repay) {
                ret.push([
                  h('Button', {
                    props: {
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.editRecord(record);
                      }
                    }
                  }, '修正信息'),
                  h('Button', {
                    props: {
                      size: 'small',
                      type: 'warning'
                    },
                    on: {
                      click: () => {
                        this.retryPay(record);
                      }
                    }
                  }, '重试')
                ]);
              }
              if (ret.length) {
                return h('div', ret);
              }
              return h('span', '-');
            }
          },
        ],
        loading: false,
        paying: false,
        getting_director_topics: false,
        updating_status: false,
        empty_tip: '获取数据中...',
        params: {
          id: this.$route.params.id,
          per_page: 20,
          page: 1,
          search: '',
          team_id: 0
        },
        page_info:{
          current: 1,
          total: 0,
          page_size: 20
        },
        edit_record: {},
        edit_config: {
          modal: false,
          loading: true
        },
        status_config: {modal: false},
        director_topics: [],
        director_topic_columns: [
          {
            title: '申请人',
            align: 'center',
            render: (h, params) => {
              const director = params.row.director;
              return h('CustomerPoptip', {
                props: { customer_id: director.id }
              }, director.account);
            }
          },
          {
            title: '月份',
            align: 'center',
            render: (h, params) => {
              const topic = params.row.topic;
              return h('span', topic.wage_month);
            }
          },
          {
            title: '工资总额',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.total_wage));
            }
          },
          {
            title: '含税总额',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.pre_tax_wage));
            }
          },
          {
            title: '状态',
            align: 'center',
            render: (h, params) => {
              const user_flow = params.row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: params.row,
                    // 完成后5天内可以驳回
                    secondsAllowedToFailAfterFinished: 5 * 24 * 3600
                  }
                });
              }
              return h('span', '已完成');
            }
          },
        ],
      }
    },
    computed: {
      isTopicFinished() {
        return this.topic.status === 5;
      },
      isTopicPaid() {
        return this.topic.status === 9;
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
        offices: 'async/offices',
        offices_hash: 'async/offices_hash',
      }),
      bank_info() {
        const obj = {} 
        const bank_info = this.topic.bank;
        const alipay_info = this.topic.alipay;
        if (bank_info || alipay_info) {
          Object.keys(bank_info).forEach((company_id) => {
            const company_name = (this.companies_hash[company_id] || {}).short_name || '未定义公司';
            if (!obj[company_name]) {
              obj[company_name] = 0
            }
            obj[company_name] += Number(bank_info[company_id])
          });
          Object.keys(alipay_info).forEach((company_id) => {
            const company_name = (this.companies_hash[company_id] || {}).short_name || '未定义公司';
            if (!obj[company_name]) {
              obj[company_name] = 0
            }
            obj[company_name] += Number(alipay_info[company_id])
          });
          return Object.keys(obj).reduce((total, key) => {
            return `${total}${key}:¥${ this.$util.formatPrice(obj[key])}；`
          }, '') || '-'
        } else {
          return '-';
        }
      },
      alipay_info() {
        const alipay_info = this.topic.alipay;
        if (alipay_info) {
          let info = '';
          Object.keys(alipay_info).forEach((company_id) => {
            const company = this.companies_hash[company_id];
            info += `${company ? company.short_name : '未定义公司'}: ￥${this.$util.formatPrice(alipay_info[company_id])} `;
          });
          return info;
        } else {
          return '-';
        }
      },
    },
    created() {
      this.getOutsourceWageTopicDetail();
    },
    methods: {
      getOutsourceWageTopicDetail() {
        if (!this.loading) {
          this.loading = true;
          this.empty_tip = '获取数据中...';
          this.$util.ajax.get(this.get_detail_path, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.handleData(data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.handleFail(e);
          });
        }
      },
      rowClassName(row, index) {
        // 废弃
        if (row.status === 6 || row.status === 7) {
          return 'color-error';
        }
        return '';
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
        this.empty_tip = '搜索结果中...';
        this.records = [];
      },
      handleData(data) {
        this.loading = false;
        this.topic = data.topic;
        this.records = [];
        // 按团队排序
        /*const records = data.records.sort((a,b)=>{
                    return a.team_id > b.team_id;
                });*/
        const records = data.records;
        records.forEach((record) => {
          this.records.push(record);
        });
        if (!records.length) {
          this.empty_tip = '暂无数据';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.empty_tip = '获取数据失败, 请重试';
        console.log(e);
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.getOutsourceWageTopicDetail();
      },
      updateTopicStatus(status) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确定要执行此操作?',
          onOk: () => {
            this.updating_status = true;
            this.$util.ajax.post(this.$util.api.update_outsource_wage_topic_status, {
              id: this.topic.id,
              status: status
            }).then((response) => {
              return response.data;
            }).then((data) => {
              if (data.code === 1) {
                this.topic.status = status;
                this.$Message.success('操作成功');
              } else {
                let err_msg = '';
                data.unfinish_directors.forEach((director) => {
                  err_msg += (director + ', ');
                });
                err_msg = err_msg.slice(0, -2);
                setTimeout(() => {
                  if (err_msg) {
                    this.$Modal.error({title: data.msg, content: err_msg})
                  } else {
                    this.$Modal.error({title: '提示', content: data.msg})
                  }
                }, 800);
              }
            }).catch((e) => {
              setTimeout(() => {
                this.$Modal.error({title: '提示', content: e.message})
              }, 600);
            }).finally(() => {
              this.updating_status = false;
            });
          }
        });
      },
      batchPay() {
        if (this.paying) return;
        this.$Modal.confirm({
          title: '提示',
          content: '你确定要执行[批量付款]操作吗?',
          onOk: () => {
            this.paying = true;
            this.$util.ajax.post(this.$util.api.outsource_wage_topic_batch_pay, {
              id: this.topic.id,
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                this.getOutsourceWageTopicDetail();
                this.$Modal.success({title: '提示', content: '批量付款已提交'});
              } else {
                this.$Modal.error({title: '错误', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '错误', content: e.message});
            }).finally(() => {
              this.paying = false;
            });
          }
        });
      },
      updateRecordDesc() {
        if (this.edit_record.desc === '<p><br></p>') {
          return;
        }
        this.$util.ajax.post(this.$util.api.outsource_wage_record_update_desc, this.edit_record).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.$Message.success('操作成功!');
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        });
      },
      editRecord(record) {
        this.edit_record = this.$util.clone(record);
        this.edit_config.modal = true;
      },
      editRecordOK() {
        this.edit_record.bank_number = this.edit_record.bank_number.replace(/\s/g, '');
        this.updateRecord();
      },
      updateRecord() {
        this.$util.ajax.post(this.$util.api.update_outsource_wage, this.edit_record).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.edit_config.modal = false;
            this.$Message.success('更新信息成功!');
            this.$util.insertOrUpdateArrayItem(this.records, res.data.record);
          } else {
            this.$Modal.error({title: '操作失败', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '操作失败', content: e.message});
        }).finally(() => {
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
        });
      },
      abandonRecord(record) {
        let msg = '<p>你确定要废弃此条记录吗?</p>';
        msg += '<p>废弃后会向当事人和负责人发送通知信息.</p>';
        msg += '<p>如有必要, 请备注废弃原因, 以备后续查阅.</p>';
        this.$Modal.confirm({
          title: '提示',
          content: msg,
          onOk: () => {
            this.$util.ajax.post(this.$util.api.abandon_outsource_wage, {
              id: record.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              console.log(data);
              if (data.code === 1) {
                this.$Message.success('废弃成功!');
                this.$util.insertOrUpdateArrayItem(this.records, data.record);
              } else {
                this.$Modal.error({title: '操作失败', content: data.msg});
              }
            }).catch((e) => {
              console.log(e);
              this.$Modal.error({title: '操作失败', content: e.message});
            });
          }
        })
      },
      recoverRecord(record) {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>你确定要恢复此条记录吗?</p>',
          onOk: () => {
            this.$util.ajax.post(this.$util.api.recover_outsource_wage, {
              id: record.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              console.log(data);
              if (data.code === 1) {
                this.$Message.success('恢复成功!');
                this.$util.insertOrUpdateArrayItem(this.records, data.record);
              } else {
                this.$Modal.error({title: '操作失败', content: data.msg});
              }
            }).catch((e) => {
              console.log(e);
              this.$Modal.error({title: '操作失败', content: '更新信息失败:' + e});
            });
          }
        })
      },
      retryPay(record) {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>你确定要重试吗?</p>',
          onOk: () => {
            this.$util.ajax.post(this.$util.api.repay_outsource_wage, {
              id: record.id
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                this.$Message.success('提交成功!');
                this.$util.insertOrUpdateArrayItem(this.records, res.data.record);
              } else {
                this.$Modal.error({title: '操作失败', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '操作失败', content: e.message});
            });
          }
        })
      },
      showFlowStatus() {
        this.status_config.modal = true;
        this.getDirectorTopicStatus();
      },
      getDirectorTopicStatus() {
        this.getting_director_topics = true;
        this.$util.ajax.get(this.$util.api.outsource_wage_topic_director_topics, {
          params: {id: this.topic.id}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.director_topics = res.data.director_topics;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.getting_director_topics = false;
        });
      },
      exportRecords(bank_type) {
        if (this.topic.id) {
          const params = `?id=${this.topic.id}&bank_type=${bank_type}`;
          window.open(this.$util.api.export_outsource_wage_topic_records_data + params, '_blank');
        } else {
          this.$Message.error('信息有误, 不能导出');
        }
      },
      exportAllRecords() {
        if (this.topic.id) {
          const params = `?id=${this.topic.id}`;
          window.open(this.$util.api.export_outsource_wage_topic_records + params, '_blank');
        } else {
          this.$Message.error('信息有误, 不能导出');
        }
      }
    }
  }
</script>
